<div class="container">
    <h4 class="section-title">Descúbrete</h4>
    <div class="content">
        <div class="content-left">
            <div class="content-chart">
                <app-radar-chart [data]="seriesApply" [events]="eventsSubject.asObservable()"></app-radar-chart>
            </div>
        </div>
        <div class="content-right">
            <div class="content-result">
                <div class="results-form">
                    <div class="result-tittle">
                        <h2><strong>{{authUser.name.split(' ')[0]}}</strong>, estos son los resultados de tu test</h2>
                    </div>
                    <div class="results-comparison">
                        <div [ngClass]="this.optionSelected==0?'result-item-selected':''"
                            class="result-item text-black">
                            <span class="dot bg-black"></span>
                            <a href="javascript:void(0)" (click)="showChartLegend(0)">Comparar</a>
                        </div>
                        <div [ngClass]="this.optionSelected==1?'result-item-selected':''"
                            class="result-item text-green">
                            <span class="dot bg-green"></span>
                            <a href="javascript:void(0)" (click)="showChartLegend(1)">Evaluación del presente</a>
                        </div>
                        <div [ngClass]="this.optionSelected==2?'result-item-selected':''" class="result-item text-red">
                            <span class="dot bg-red"></span>
                            <a href="javascript:void(0)" (click)="showChartLegend(2)">Evaluación del futuro</a>
                        </div>
                    </div>

                    <div #barChart class="barChart"></div>
                </div>
            </div>
        </div>
    </div>
</div>